var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "create-edit-payment-link" },
    [
      _c("div", { staticClass: "page-title application-detail-header" }, [
        _c("i", {
          staticClass: "el-icon-arrow-left icon-back",
          on: { click: _vm.goBack },
        }),
        _vm._v(" " + _vm._s(_vm.title) + " "),
      ]),
      _vm.type === "detail" && _vm.paymentLinkInfo.status
        ? _c(
            "div",
            { staticClass: "title" },
            [
              _c("span", [_vm._v(_vm._s(_vm.paymentLinkInfo.title))]),
              _vm._v(" "),
              _c(
                "el-tag",
                {
                  staticClass: "tag-custom",
                  attrs: {
                    type: _vm.activeStatusMap(_vm.paymentLinkInfo.status).type,
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.activeStatusMap(_vm.paymentLinkInfo.status).label
                    )
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.type === "detail"
        ? _c(
            "div",
            { staticClass: "link" },
            [
              _c("span", { staticClass: "link-url" }, [
                _vm._v(_vm._s(_vm.paymentLinkInfo.link_url)),
              ]),
              _c(
                "el-button",
                {
                  staticClass: "btn-copy",
                  attrs: {
                    icon: "el-icon-copy-document",
                    size: "mini",
                    type: "primary",
                    "data-clipboard-text": _vm.paymentLinkInfo.link_url,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.onClickCopyBtn(".btn-copy", "Link")
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$t("payment_links.copy_link")) + " ")]
              ),
              _c(
                "el-popover",
                { attrs: { placement: "bottom", trigger: "hover" } },
                [
                  _c("img", {
                    attrs: { src: _vm.link_qr_base64, alt: "", width: "300px" },
                  }),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "12px" },
                      attrs: { slot: "reference", size: "mini" },
                      slot: "reference",
                    },
                    [_vm._v(_vm._s(_vm.$t("payment_links.show_qr_code")))]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.type !== "detail"
        ? _c("PaymentLink")
        : [
            _c(
              "el-tabs",
              {
                attrs: { type: "card" },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              [
                _vm._l(_vm.componentConfig, function (item, index) {
                  return [
                    _c("el-tab-pane", {
                      key: index,
                      attrs: { label: item.label, name: item.compName },
                    }),
                  ]
                }),
              ],
              2
            ),
            _c(
              "keep-alive",
              [
                _c(_vm.activeName, {
                  key: _vm.activeName,
                  tag: "component",
                  on: { getInfo: _vm.getInfo },
                }),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }